import BrixLogoColor from "../../../../enums/BrixLogoColor";

import { BrixLogoLaNo } from "../../../../assets/img/logos/BrixLogoLaNo.jsx"
import { BrixLogoLaYes } from "../../../../assets/img/logos/BrixLogoLaYes.jsx"
import { BrixLogoHpNo } from "../../../../assets/img/logos/BrixLogoHpNo.jsx"
import { BrixLogoHpYes } from "../../../../assets/img/logos/BrixLogoHpYes.jsx"
import { BrixLogoMyNo } from "../../../../assets/img/logos/BrixLogoMyNo.jsx"
import { BrixLogoMyYes } from "../../../../assets/img/logos/BrixLogoMyYes.jsx"
import { BrixLogoGrNo } from "../../../../assets/img/logos/BrixLogoGrNo.jsx"
import { BrixLogoGrYes } from "../../../../assets/img/logos/BrixLogoGrYes.jsx"
import { BrixLogoEbNo } from "../../../../assets/img/logos/BrixLogoEbNo.jsx"
import { BrixLogoEbYes } from "../../../../assets/img/logos/BrixLogoEbYes.jsx"
import { BrixLogoWhNo } from "../../../../assets/img/logos/BrixLogoWhNo.jsx"
import { BrixLogoWhYes } from "../../../../assets/img/logos/BrixLogoWhYes.jsx"
import { BrixLogoBlNo } from "../../../../assets/img/logos/BrixLogoBlNo.jsx"
import { BrixLogoBlYes } from "../../../../assets/img/logos/BrixLogoBlYes.jsx"
import { BrixLogoBoYes } from "../../../../assets/img/logos/BrixLogoBoYes.jsx"
import { BrixLogoBoNo } from "../../../../assets/img/logos/BrixLogoBoNo.jsx"
import { BrixLogoPhYes } from "../../../../assets/img/logos/BrixLogoPhYes.jsx"
import { BrixLogoPhNo } from "../../../../assets/img/logos/BrixLogoPhNo.jsx"

function BrixLogo(props) {
    const logo = getLogo(props);
    return logo;
}

const getLogo = (props) => {
    switch (props.color) {
        case BrixLogoColor.lifeAquatic:
            return (
                props.isIconOnly ? <BrixLogoLaYes className={props.className} /> : <BrixLogoLaNo className={props.className} />
            );
        case BrixLogoColor.bloodOrange:
            return (
                props.isIconOnly ? <BrixLogoBoYes className={props.className} /> : <BrixLogoBoNo className={props.className} />
            );
        case BrixLogoColor.hotPink:
            return (
                props.isIconOnly ? <BrixLogoHpYes className={props.className} /> : <BrixLogoHpNo className={props.className} />
            );
        case BrixLogoColor.purpleHaze:
            return (
                props.isIconOnly ? <BrixLogoPhYes className={props.className} /> : <BrixLogoPhNo className={props.className} />
            )
        case BrixLogoColor.mellowYellow:
            return (
                props.isIconOnly ? <BrixLogoMyYes className={props.className} /> : <BrixLogoMyNo className={props.className} />
            );
        case BrixLogoColor.grey:
            return (
                props.isIconOnly ? <BrixLogoGrYes className={props.className} /> : <BrixLogoGrNo className={props.className} />
            );
        case BrixLogoColor.electricBlue:
            return (
                props.isIconOnly ? <BrixLogoEbYes className={props.className} /> : <BrixLogoEbNo className={props.className} />
            );
        case BrixLogoColor.white:
            return (
                props.isIconOnly ? <BrixLogoWhYes className={props.className} /> : <BrixLogoWhNo className={props.className} />
            );
        case BrixLogoColor.black:
            return (
                props.isIconOnly ? <BrixLogoBlYes className={props.className} /> : <BrixLogoBlNo className={props.className} />
            );
        default:
            return (
                props.isIconOnly ? <BrixLogoLaYes className={props.className} /> : <BrixLogoLaNo className={props.className} />
            );
    }
}

export default BrixLogo